module.exports = __webpack_public_path__ + "static/media/michael.0b276fd5.jpg";